import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SpinnerFullPageComponent } from './shared/spinner-full-page/spinner-full-page.component';
import { CommonModule } from '@angular/common';
import { distinctUntilChanged, Observable } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { CacheService } from './services/cache.service';
import { DialogType } from './services/model/dialog-type.enum';
import { DataService } from './services/data.service';
import { ExecutingTaskMonitorService } from './services/executing-task-monitor.service';
import { NotificationMessage } from './services/model/notification-message.model';
import { PlatformModule, Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    FooterComponent,
    HeaderComponent,
    CommonModule,
    SpinnerFullPageComponent,
    ToastModule,
    RippleModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  providers: [MessageService],
})
export class AppComponent implements OnInit {
  public title = 'portal-app';

  constructor(
    private readonly _cache: CacheService,
    private readonly _messageService: MessageService,
    private readonly _dataService: DataService,
    private readonly _executingTaskSvc: ExecutingTaskMonitorService,
    private readonly _platform: Platform,
  ) {
    this._cache.showDialog.subscribe((data) => {
      let detail: string = this.getMessage(data.messages ?? []);
      switch (data.dialogType) {
        case DialogType.error:
          this._messageService.add({
            severity: 'error',
            summary: data.title,
            detail: detail,
            sticky: true,
          });
          break;
        case DialogType.info:
          this._messageService.add({
            severity: 'info',
            summary: data.title,
            detail: detail,
            life: 5000,
          });
          break;
        case DialogType.warning:
          this._messageService.add({
            severity: 'warn',
            summary: data.title,
            detail: detail,
            life: 5000,
          });
          break;
        default:
          break;
      }
    });
  }

  ngOnInit(): void {}

  private showWarningMessage(message: string, title: string) {
    this._cache.showDialog.next(
      new NotificationMessage(DialogType.warning, title, [message]),
    );
  }

  private getMessage(data: string[]): string {
    let message: string = '';
    try {
      if (data != null || data != undefined) {
        if (data.length > 0) {
          for (const element of data) {
            message = `${message} ${element}`;
          }
        }
      }
    } catch (error) {
      console.error('getMessage', error);
    }
    return message;
  }
}
